import actions from './actions';
import mutations from './mutations';

const deliveryProducts = {
  namespaced: true,
  state: {
    allItems: [],
    items: [],
    pagination: {
      page: 1,
      totalPages: 1
    },
    filters: {
      query: null,
      brandId: null,
      establishmentId: null,
      type: 'active'
    }
  },
  mutations,
  actions
};

export default deliveryProducts;
